import React, { useEffect, useRef } from 'react';
import { ModalV2, ModalV2Title, ModalV2Content } from '@design-system-etat/dsfr-react';
import { useHistory } from 'react-router-dom';
import RoutesDeconnexion from '../../pages/deconnexion/routes';
import { getPath } from '../../utils/router';

const ModaleDeconnexion = () => {
    const history = useHistory();

    const deconnexion = () => {
        history.push(getPath(RoutesDeconnexion));
    };

    const dialog = useRef();

    useEffect(() => {
        if (dialog.current) {
            dialog.current.showModal();
        }
    }, [dialog]);

    return (
        <ModalV2
            title="Déconnexion"
            id="modal-deconnexion"
            idModalTitle="modal-deconnexion-title"
            onClose={deconnexion}
            ref={dialog}
        >
            <ModalV2Content>
                <ModalV2Title id="modal-deconnexion-title">Déconnexion</ModalV2Title>
                Vous allez être déconnecté en raison de la mise à jour de votre compte. Merci de
                vous reconnecter.
            </ModalV2Content>
        </ModalV2>
    );
};

export default ModaleDeconnexion;
